export default __webpack_public_path__ + "static/media/ajanvaraus-darkblue.aba91e32.svg";